import { ref } from "vue";
import { set } from "@vueuse/core";
import { useRuntimeConfig } from "#app";
import { Configuration, FrontendApi } from "@ory/client";
export const useLogout = () => {
  const config = useRuntimeConfig();
  const logout = ref(null);
  const ory = new FrontendApi(
    new Configuration({
      basePath: config.public.oryUrl,
      baseOptions: {
        withCredentials: true
      }
    })
  );
  ory.createBrowserLogoutFlow().then(({ data }) => {
    set(logout, data.logout_url);
  }).catch((_err) => {
    set(logout, "#");
  });
  return logout;
};
